import type { ClientType } from '@/types/controlCenter'

import type { FlagColumnConfig } from './types'

// ── Page size ─────────────────────────────────────────────────────────────────

export const PAGE_SIZE = 10

// ── Client badge styles (one entry per ClientType) ────────────────────────────

export const CLIENT_BADGE: Record<ClientType, string> = {
  peacock: 'bg-blue-900/40 text-blue-300 border border-blue-800/50',
  global: 'bg-emerald-900/40 text-emerald-300 border border-emerald-800/50',
  'global-ott': 'bg-teal-900/40 text-teal-300 border border-teal-800/50',
  'nbcu-dtc': 'bg-cyan-900/40 text-cyan-300 border border-cyan-800/50',
  nowott: 'bg-orange-900/40 text-orange-300 border border-orange-800/50',
  'sky-europe': 'bg-sky-900/40 text-sky-300 border border-sky-800/50',
  skyshowtime: 'bg-purple-900/40 text-purple-300 border border-purple-800/50',
}

// ── Column definitions ────────────────────────────────────────────────────────

export const COLUMN_CONFIG: FlagColumnConfig[] = [
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    className: 'w-[40%] max-w-[40%] min-w-[40%]',
  },
  { key: 'client', label: 'Client', sortable: true },
  { key: 'status', label: 'Status', sortable: true },
  { key: 'global', label: 'Global', sortable: true },
  { key: 'lastModified', label: 'Modified', sortable: true },
  { key: 'actions', label: 'Actions', sortable: false },
]
